import { TooltipProps } from './types';

export function CustomTooltip({ active, payload, label }: TooltipProps) {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-background border rounded-lg shadow-lg p-2">
      <p className="text-sm font-medium">{label}</p>
      <p className="text-sm text-muted-foreground">
        Issues: {payload[0].value}
      </p>
    </div>
  );
}